import api from '@/lib/api/axios'
import type { Technology } from '@/types/entities'
import type { ListParams, PaginatedResponse } from '@/lib/api/types'

export const technologiesApi = {
    list: (params?: ListParams) => {
        // Convert perPage to limit for backend compatibility
        const queryParams = params ? {
            ...params,
            limit: params.perPage || params.limit || 20,
            perPage: undefined,
        } : undefined
        // Remove undefined values
        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                if (queryParams[key as keyof typeof queryParams] === undefined) {
                    delete queryParams[key as keyof typeof queryParams]
                }
            })
        }
        return api.get<PaginatedResponse<Technology>>('/api/technologies', { params: queryParams })
    },

    get: (id: number) =>
        api.get<Technology>(`/api/technologies/${id}`),

    create: (data: { manufacturerId: number; categoryId: number; model: string; description?: string | null; isSaaS?: boolean }) =>
        api.post<Technology>('/api/technologies', data),

    update: (id: number, data: { manufacturerId: number; categoryId: number; model: string; description?: string | null; isSaaS?: boolean }) =>
        api.put<Technology>(`/api/technologies/${id}`, data),

    delete: (id: number) =>
        api.delete(`/api/technologies/${id}`),

    import: (file: File) => {
        const formData = new FormData()
        formData.append('file', file)
        return api.post<{ success: boolean; data: { totalInFile: number; imported: number; skipped: number; errorCount: number; errors: Array<{ row: number; model?: string; error: string }> } }>(
            '/api/technologies/import',
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        )
    },
}
